var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCoolerVectorLine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1898,
    height: 158,
    viewBox: "0 0 1898 158",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M786.086 91.9319C786.086 91.9319 651.405 -68.8406 387.015 74.4448C122.625 217.73 0.996929 91.9319 0.996929 91.9319",
    stroke: "url(#paint0_linear_680_596)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M786.086 66.0681C786.086 66.0681 976.662 226.841 1350.78 83.5552C1724.89 -59.7303 1897 66.0681 1897 66.0681",
    stroke: "url(#paint1_linear_680_596)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 80.0681C1 80.0681 135.681 240.841 400.071 97.5552C664.461 -45.7303 786.089 80.0681 786.089 80.0681",
    stroke: "url(#paint2_linear_680_596)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1897 77.9319C1897 77.9319 1706.42 -82.8406 1332.31 60.4448C958.194 203.73 786.089 77.9319 786.089 77.9319",
    stroke: "url(#paint3_linear_680_596)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M786.086 77.9319C786.086 77.9319 651.405 -82.8406 387.015 60.4448C122.625 203.73 0.996929 77.9319 0.996929 77.9319",
    stroke: "url(#paint4_linear_680_596)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M786.086 80.0681C786.086 80.0681 976.662 240.841 1350.78 97.5552C1724.89 -45.7303 1897 80.0681 1897 80.0681",
    stroke: "url(#paint5_linear_680_596)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1 66.0681C1 66.0681 135.681 226.841 400.071 83.5552C664.461 -59.7303 786.089 66.0681 786.089 66.0681",
    stroke: "url(#paint6_linear_680_596)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1897 91.9319C1897 91.9319 1706.42 -68.8406 1332.31 74.4448C958.194 217.73 786.089 91.9319 786.089 91.9319",
    stroke: "url(#paint7_linear_680_596)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1 80.0681C1 80.0681 326.257 240.841 964.762 97.5552C1603.27 -45.7303 1897 80.0681 1897 80.0681",
    stroke: "url(#paint8_linear_680_596)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1 66.0681C1 66.0681 326.257 226.841 964.762 83.5552C1603.27 -59.7303 1897 66.0681 1897 66.0681",
    stroke: "url(#paint9_linear_680_596)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1897 91.9319C1897 91.9319 1571.74 -68.8406 933.238 74.4448C294.732 217.73 0.999957 91.9319 0.999957 91.9319",
    stroke: "url(#paint10_linear_680_596)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1897 77.9319C1897 77.9319 1571.74 -82.8406 933.238 60.4448C294.732 203.73 0.999957 77.9319 0.999957 77.9319",
    stroke: "url(#paint11_linear_680_596)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_680_596",
    x1: 937.859,
    y1: 92.085,
    x2: -393.5,
    y2: -25.8806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.244792,
    stopColor: "#EB1E43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#A11692"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A11692",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_680_596",
    x1: 571.325,
    y1: 65.915,
    x2: 2440.62,
    y2: 300.283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.244792,
    stopColor: "#EB1E43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#A11692"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A11692",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_680_596",
    x1: -150.773,
    y1: 79.915,
    x2: 1180.59,
    y2: 197.881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.244792,
    stopColor: "#EB1E43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#A11692"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A11692",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_680_596",
    x1: 2111.76,
    y1: 78.085,
    x2: 242.465,
    y2: -156.283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.244792,
    stopColor: "#EB1E43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#A11692"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A11692",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_680_596",
    x1: 937.859,
    y1: 78.085,
    x2: -393.5,
    y2: -39.8806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.244792,
    stopColor: "#EB1E43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#A11692"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A11692",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_680_596",
    x1: 571.325,
    y1: 79.915,
    x2: 2440.62,
    y2: 314.283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.244792,
    stopColor: "#EB1E43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#A11692"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A11692",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_680_596",
    x1: -150.773,
    y1: 65.915,
    x2: 1180.59,
    y2: 183.881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.244792,
    stopColor: "#EB1E43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#A11692"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A11692",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_680_596",
    x1: 2111.76,
    y1: 92.085,
    x2: 242.465,
    y2: -142.283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.244792,
    stopColor: "#EB1E43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#A11692"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A11692",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_680_596",
    x1: -365.534,
    y1: 79.915,
    x2: 2733.08,
    y2: 742.965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.244792,
    stopColor: "#EB1E43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#A11692"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A11692",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_680_596",
    x1: -365.534,
    y1: 65.915,
    x2: 2733.08,
    y2: 728.965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.244792,
    stopColor: "#EB1E43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#A11692"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A11692",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_680_596",
    x1: 2263.53,
    y1: 92.085,
    x2: -835.076,
    y2: -570.965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.244792,
    stopColor: "#EB1E43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#A11692"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A11692",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_680_596",
    x1: 2263.53,
    y1: 78.085,
    x2: -835.076,
    y2: -584.965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.244792,
    stopColor: "#EB1E43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#A11692"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A11692",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoolerVectorLine);
export default __webpack_public_path__ + "static/media/cooler-vector-line.fc7abb9198c8776722599071c0e20153.svg";
export { ForwardRef as ReactComponent };